import * as React from 'react';

import CompetitiveSetStep from './CompetitiveSetStep';
import DemographicsStep from './DemographicsStep';
import MixAndMatchStep from './MixAndMatchStep';
import OptimizationStep from './OptimizationStep';
import OptionsStep from './OptionsStep';
import ParentStep, { ParentDetailsStatus } from './ParentStep';
import ProjectStep from './ProjectStep';
import SourceStep from './SourceStep';
import { StepProps } from './types';
import TypeStep from './TypeStep';
import { ParentReportRow } from '../hooks/useParentReports';
import { ProductCatalog } from '../hooks/useProductCatalog';
import { StepId } from '../model/steps';

export interface StepContentProps extends StepProps {
  stepId: StepId;
  isSuperAdmin: boolean;
  producerId: number;
  catalog: ProductCatalog;
  missingProducts: string[];
  parentReports: { reports: ParentReportRow[]; loading: boolean; error?: { message: string } };
  parentDetails: ParentDetailsStatus & {
    refFlavors: string[];
    refFlavorsLoading: boolean;
    flavorShares?: ReadonlyMap<string, ReadonlyMap<string, number>>;
    flavorSharesLoading?: boolean;
    flavorSharesError?: { message: string };
  };
}

/** Renders the fields of one section of the form. */
const StepContent: React.FC<StepContentProps> = (props) => {
  const { stepId, state, dispatch, errors } = props;
  const stepProps: StepProps = { state, dispatch, errors };

  switch (stepId) {
    case 'type':
      return <TypeStep {...stepProps} />;
    case 'project':
      return <ProjectStep {...stepProps} currentWorkspaceId={props.producerId} />;
    case 'source':
      return <SourceStep {...stepProps} />;
    case 'demographics':
      return <DemographicsStep {...stepProps} producerId={props.producerId} />;
    case 'competitiveSet':
      return (
        <CompetitiveSetStep {...stepProps} catalog={props.catalog} missingProducts={props.missingProducts} />
      );
    case 'parent':
      return (
        <ParentStep
          {...stepProps}
          reports={props.parentReports.reports}
          reportsLoading={props.parentReports.loading}
          reportsError={props.parentReports.error}
          details={props.parentDetails}
        />
      );
    case 'optimization':
      return (
        <OptimizationStep
          {...stepProps}
          refFlavors={props.parentDetails.refFlavors}
          refFlavorsLoading={props.parentDetails.refFlavorsLoading}
          flavorShares={props.parentDetails.flavorShares}
          flavorSharesLoading={props.parentDetails.flavorSharesLoading}
          flavorSharesError={props.parentDetails.flavorSharesError}
        />
      );
    case 'mixAndMatch':
      return <MixAndMatchStep {...stepProps} />;
    case 'options':
      return <OptionsStep {...stepProps} isSuperAdmin={props.isSuperAdmin} />;
    default:
      return null;
  }
};

export default StepContent;
